import {BaseCachedService} from './Core/BaseCachedService';

class SurveyAnswerPlantQuantityStockTypeService extends BaseCachedService {
    get Url() { return super.Url + "/surveyAnswerPlantQuantityStockTypes"; }
    get TitleProperty() { return "name"; }
    get PrimaryKeyProperty() { return "surveyAnswerPlantQuantityStockTypeId"; }
    get ModelName() { return "Stock Type"; }
}

export const service = new SurveyAnswerPlantQuantityStockTypeService();

